import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

class Select extends Component {
  state = {
    isActiveLabel: false,
  };

  static propTypes = {
    htmlId: PropTypes.string,
    name: PropTypes.string,
    defaultValue: PropTypes.string,
    required: PropTypes.bool,
  };

  static defaultProps = {
    htmlId: 'id',
    name: 'name',
    defaultValue: '',
    required: false,
  };

  handleChange = () => {
    this.setState({ isActiveLabel: true });
  };

  render() {
    const { htmlId, name, defaultValue, label, required, children } = this.props;

    return (
      <Root {...this.props}>
        <select
          name={name}
          id={htmlId}
          defaultValue={defaultValue}
          required={required}
          onChange={this.handleChange}
        >
          {children}
        </select>
        <Label active={this.state.isActiveLabel ? 1 : 0}>{label}</Label>
      </Root>
    );
  }
}

const transitionDuration = 0.15;

const Root = styled.div`
  width: 100%;
  position: relative;
  select {
    width: 100%;
    border-bottom: 1px solid #ffffff;
  }
`;

const Label = styled.label`
  font-size: ${props => (props.active ? '12px' : '14px')};
  position: absolute;
  bottom: ${props => (props.active ? '37px' : '10px')};
  left: 10px;
  opacity: ${props => (props.active ? 1 : 0)};
  transition: all ${transitionDuration}s ease-out;
  pointer-events: none;
`;

export default Select;



// WEBPACK FOOTER //
// ./src/pages/Register/elements/Form/elements/Select.js